const STORAGE_KEY = 'invite-auto-accept-token';

export const inviteAutoAcceptIntent = {
  set(token: string) {
    try {
      sessionStorage.setItem(STORAGE_KEY, token);
    } catch {}
  },
  peek(): string | null {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  },
  take(): string | null {
    try {
      const token = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      return token;
    } catch {
      return null;
    }
  },
};
